import Container from 'components/Containers/Container';
import React from 'react';
import { CaretDownOutlined, CaretUpOutlined, DeleteOutlined, PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
import { Button, Col, Popconfirm, Row, Select, Space, Tooltip } from 'antd';
import Card from 'components/Containers/Card';
import { query } from 'helpers/QueryHelper';
import DynamicTable from 'packages/DynamicForm/components/DynamicTable';
import PropTypes from 'prop-types';
import { useQuery, useQueryClient } from 'react-query';
import ReactQuill from 'react-quill';
import { useHistory, useParams } from 'react-router';
import { tableColumns } from './data';
import { useSelector } from 'react-redux';
import { NotificationProps } from './type';
import { deleteUserNotificationApi, getNotificationListApi, updateNotificationStatusApi } from './api/NotificationApis';
import InsertUpdateNotification from './components/InsertUpdateNotification';
import AdministratorContainer from 'components/Containers/AdministratorContainer';
import { paginationTable } from 'constants/Pagination';

type Props = {};

const Notifications = (props: Props) => {
  const loggedInUser = useSelector((state) => state.authReducer.loggedInUser);
  const searchParams = new URLSearchParams(window.location.search);

  const [searchPaging, setSearchPaging] = React.useState<{ pageNumber: number; pageSize: number }>({ pageNumber: 1, pageSize: 10 });
  const [selectedRecord, setSelectedRecord] = React.useState(null);
  const [expandedRowKeys, setExpandedRowKeys] = React.useState([]);
  const [selectedManyNotifications, setSelectedManyNotifications] = React.useState<any[]>([]);
  const queryClient = useQueryClient();

  const KEY_GET_NOTIFICATIONS = 'p_SACHSO_ThongBao_NguoiDung_DanhSach';
  const { data: notificationList, isLoading } = useQuery([KEY_GET_NOTIFICATIONS, searchPaging], () =>
    getNotificationListApi({
      UserId: loggedInUser?.id ?? 0,
      PageNum: searchPaging.pageNumber,
      PageSize: searchPaging.pageSize,
    }),
  );

  const id = searchParams.get('id');

  const rowSelection = {
    selectedRowKeys: selectedManyNotifications,
    onChange: (selectedRowKeys: any[], selectedRows: any[]) => {
      setSelectedManyNotifications(selectedRowKeys);
    },
  };

  React.useEffect(() => {
    if (id) {
      updateNotificationStatus(Number(id));
      setExpandedRowKeys([Number(id)]);
    }
  }, [id]);

  const onRefreshData = () => {
    queryClient.invalidateQueries(KEY_GET_NOTIFICATIONS);
    setSelectedManyNotifications([]);
  };
  const onDeleteNotification = (id: number) => async () => {
    deleteUserNotificationApi({ ThongBaoId: id, UserId: loggedInUser?.id }).then((res) => {
      onRefreshData();
    });
  };

  const updateNotificationStatus = (id: number) => {
    updateNotificationStatusApi({ ThongBaoId: id, UserId: loggedInUser.id, TrangThai: 1 }).then(() => {
      onRefreshData();
    });
  };

  return (
    <Container name='Thông báo' parentName=''>
      <Card
        title='Thông báo'
        bodyStyles={{ paddingTop: 0, paddingBottom: 0 }}
        extra={
          <AdministratorContainer>
            <Space>
              <Button
                icon={<PlusOutlined />}
                onClick={() => {
                  setSelectedRecord({});
                }}
              >
                Tạo thông báo
              </Button>
            </Space>
          </AdministratorContainer>
        }
      >
        <DynamicTable
          rowKey={'thongBaoId'}
          loading={isLoading}
          expandable={{
            columnWidth: '1%',
            expandedRowKeys: expandedRowKeys,

            expandedRowRender: (record: NotificationProps) => {
              return (
                <div>
                  {/* {content} */}
                  <div className='text-sm mb-0' dangerouslySetInnerHTML={{ __html: record.content ?? '' }} style={{ maxHeight: 300, overflowY: 'auto' }} />
                  <Row justify='end'>
                    <Popconfirm title='Bạn có chắc chắn muốn xoá không?' onConfirm={onDeleteNotification(record.thongBaoId)} okText='Xoá' cancelText='Đóng'>
                      <Tooltip title='Xoá' placement='bottom'>
                        <Button key='delete-notification' shape='circle' type='dashed' icon={<DeleteOutlined />} danger />
                      </Tooltip>
                    </Popconfirm>
                  </Row>
                </div>
              );
            },
            expandIconColumnIndex: 999,
            expandRowByClick: true,
            onExpand: (expanded: boolean, record: NotificationProps) => {
              if (expanded) {
                updateNotificationStatus(record.thongBaoId);
                setExpandedRowKeys((pre) => [...pre, record.thongBaoId]);
              } else {
                setExpandedRowKeys((pre) => pre.filter((i) => i !== record.thongBaoId));
              }
            },
          }}
          dataSource={notificationList}
          initialTableData={tableColumns}
          pagination={paginationTable({
            pageNumber: searchPaging.pageNumber,
            pageSize: searchPaging.pageSize,
            totalRows: notificationList?.[0]?.totalRows,
            onChange(page, pageSize) {
              setSearchPaging({ pageNumber: page, pageSize: pageSize });
            },
          })}
          // rowSelection={rowSelection}
        />
      </Card>
      <InsertUpdateNotification data={selectedRecord} onRefreshData={onRefreshData} />
    </Container>
  );
};

export default Notifications;
